module.exports = __webpack_public_path__ + "img/59.6.CODm.b9041ded.png";